var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M18,20 L21,20 L21,17 L18,17 L18,20 Z M3,20 L6,20 L6,17 L3,17 L3,20 Z M18,15 L21,15 L21,12 L18,12 L18,15 Z M13,15 L16,15 L16,12 L13,12 L13,15 Z M13,20 L16,20 L16,17 L13,17 L13,20 Z M8,20 L11,20 L11,17 L8,17 L8,20 Z M8,15 L11,15 L11,12 L8,12 L8,15 Z M3,15 L6,15 L6,12 L3,12 L3,15 Z M18,10 L21,10 L21,7 L18,7 L18,10 Z M13,10 L16,10 L16,7 L13,7 L13,10 Z M3,10 L6,10 L6,7 L3,7 L3,10 Z M8,10 L11,10 L11,7 L8,7 L8,10 Z M22,2 L2,2 C1.447,2 1,2.448 1,3 L1,21 C1,21.553 1.447,22 2,22 L22,22 C22.553,22 23,21.553 23,21 L23,3 C23,2.448 22.553,2 22,2 L22,2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTable);
export default __webpack_public_path__ + "static/media/black-table.cc5b1f000da995195533d327bb42c748.svg";
export { ForwardRef as ReactComponent };